export default __webpack_public_path__ + "static/media/mvp.4173f339.jpeg";